import { TYPES } from "./roster.type";

const initState = {
  roster: null,
  lockRoster: null,
  previousRoster: null,
};

const rosterReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ROSTER_LIST_SUCCESS:
      return {
        ...state,
        roster: payload,
      };

    case TYPES.SELECT_LOCK_ROSTER_LIST_SUCCESS:
      return {
        ...state,
        lockRoster: payload,
      };
    case TYPES.SET_PREVIOUS_ROSTER_SUCCESS:
      return {
        ...state,
        previousRoster: payload,
      };

    default:
      return state;
  }
};

export default rosterReducer;
